import { useSelector } from 'react-redux'
import { selectMerchant } from 'selectors/merchant'

export default function useIsDemo() {
  return useSelector(
    (state: any) =>
      selectMerchant(state, state.auth.current_merchant_id)?.state === 'demo'
  )
}
